export const AI_AUTOMATION_ATTEMPTED_STORAGE_KEY =
  "aiAutomationAttempted.vpn" as const;
